import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody } from "reactstrap";
import { AsyncBoundary } from "../StatusStates";

/**
 * 看板 Widget 共用框架（主計劃：狀態共用看板框架）。
 *
 * Dashboard 26 張 widget 共用同一外殼與 骨架/無資料/錯誤 狀態，
 * 內容（統計數字或圖表）由使用端塞入。
 */

// 統計數字型 widget（待辦數、EOL 數量、機櫃U數…）
export const StatWidget = ({ title, value, unit, icon, color = "primary", loading, error, onRetry }) => (
  <Card className="mb-0 h-100">
    <CardBody>
      <AsyncBoundary loading={loading} error={error} onRetry={onRetry} skeleton={<div className="placeholder-glow"><span className="placeholder col-8" /></div>}>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-muted mb-1">{title}</p>
            <h4 className="mb-0">
              {value}
              {unit ? <small className="text-muted ms-1">{unit}</small> : null}
            </h4>
          </div>
          {icon ? (
            <div className={`avatar-sm rounded-circle bg-${color}-subtle d-flex align-items-center justify-content-center`}>
              <i className={`mdi ${icon} text-${color}`} style={{ fontSize: 22 }} />
            </div>
          ) : null}
        </div>
      </AsyncBoundary>
    </CardBody>
  </Card>
);
StatWidget.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  unit: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  onRetry: PropTypes.func,
};

// 圖表型 widget（趨勢圖、分布圖…），children 放 <Chart />
export const ChartWidget = ({ title, extra, loading, error, isEmpty, onRetry, children }) => (
  <Card className="mb-0 h-100">
    <CardBody>
      <div className="d-flex align-items-center mb-2">
        <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
        {extra}
      </div>
      <AsyncBoundary
        loading={loading}
        error={error}
        isEmpty={isEmpty}
        onRetry={onRetry}
        skeleton={<div className="placeholder-glow"><span className="placeholder col-12" style={{ height: 180 }} /></div>}
      >
        {children}
      </AsyncBoundary>
    </CardBody>
  </Card>
);
ChartWidget.propTypes = {
  title: PropTypes.string,
  extra: PropTypes.node,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  isEmpty: PropTypes.bool,
  onRetry: PropTypes.func,
  children: PropTypes.node,
};

export default StatWidget;
